module.exports = __webpack_public_path__ + "images/ai-insights-f6dde439.svg";